import { Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <Container
      maxWidth="sm"
      sx={{
        textAlign: "center",
        mt: 15,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography variant="h4" gutterBottom color="error">
        Unexpected Application Error
      </Typography>
      <Typography variant="body1" gutterBottom>
        Something went wrong while loading this page.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 3 }}
        onClick={() => navigate("/")}
      >
        Go Home
      </Button>

      <Button
        variant="outlined"
        color="secondary"
        sx={{ mt: 2 }}
        onClick={() => window.location.reload()}
      >
        Retry
      </Button>
    </Container>
  );
};

export default ErrorPage;
